"use client"

import { useGetAllCategories } from "@/apis/categories/Queries"
// import { ChevronDown } from "lucide-react"
import * as React from "react"
import { useNavigate } from "react-router"


export function CategoryDropdown({ onSelect }: { onSelect?: () => void }) {
  const Allcategories=useGetAllCategories()
  const [activeCategory] = React.useState<string | null>(null)
  // const [expandedMobileCategory] = React.useState<string | null>(null)
  const navigate = useNavigate()
  const categories = Allcategories?.data || [] as any[]
  const isLoading = (Allcategories as any)?.isLoading
  // const isError = Boolean((Allcategories as any)?.error)

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/categories/${categoryId}`)
    if (onSelect) onSelect()
  }
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Desktop/Tablet View - Horizontal Categories */}
      <div className="hidden sm:block">
        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2 border-b border-gray-200 pb-3">
          {isLoading && (
            <>
              {Array.from({ length: 10 }).map((_, i) => (
                <div key={i} className="h-8 w-24 bg-gray-100 animate-pulse rounded-md" />
              ))}
            </>
          )}
          {!isLoading && categories?.length > 0 && categories.map((category: any) => (
            <button
              key={category?._id || category?.name}
              onClick={() => handleCategoryClick(category._id)}
              className={`px-3 md:px-4 py-2 cursor-pointer text-sm md:text-[15px] font-medium rounded-md transition-colors duration-200 border border-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500/40 focus-visible:border-red-200 ${activeCategory === category?.name
                  ? "bg-red-100 text-red-700 border border-red-200"
                  : "text-gray-700 hover:text-red-600 hover:bg-gray-50"
                }`}
            >
              {category?.name}
            </button>
          ))}
          {!isLoading && !categories?.length && (
            <p className="text-sm text-gray-500 py-2">No categories found.</p>
          )}
        </div>

        {/* Category Content */}
        {/* {activeCategory && (
          <div className="max-h-96 overflow-y-auto">
            {categories
              .find((cat) => cat.name === activeCategory)
              ?.subcategories.map((subcategory) => (
                <div key={subcategory.title} className="mb-6">
                  <h3 className="font-semibold text-red-600 text-sm uppercase tracking-wide border-b border-red-200 pb-2 mb-3">
                    {subcategory.title}
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                    {subcategory.items.map((item) => (
                      <button
                        key={item}
                        className="text-left text-sm text-gray-600 hover:text-red-600 hover:font-medium transition-all duration-150 py-1 px-2 rounded hover:bg-red-50"
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        )} */}
      </div>

      {/* Mobile View - Vertical Accordion */}
      <div className="sm:hidden">
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {isLoading && (
            <>
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={`m-skel-${i}`} className="h-10 w-full bg-gray-100 animate-pulse rounded-lg" />
              ))}
            </>
          )}
          {!isLoading && categories?.map((category:any) => (
            <div key={category?._id || category?.name} className="border border-gray-200 rounded-lg">
              <button
                onClick={() => handleCategoryClick(category._id)}
                className="flex justify-between items-center w-full px-4 py-3 text-left text-sm font-medium text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <span className="truncate">{category?.name}</span>
              </button>

              {/* {expandedMobileCategory === category.name && (
                <div className="px-4 pb-4 border-t border-gray-100">
                  {category.subcategories.map((subcategory) => (
                    <div key={subcategory.title} className="mt-4">
                      <h3 className="font-semibold text-red-600 text-xs uppercase tracking-wide border-b border-red-200 pb-1 mb-2">
                        {subcategory.title}
                      </h3>
                      <div className="space-y-1">
                        {subcategory.items.map((item) => (
                          <button
                            key={item}
                            className="block w-full text-left text-xs text-gray-600 hover:text-red-600 py-1 px-2 rounded hover:bg-red-50 transition-colors"
                          >
                            {item}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )} */}
            </div>
          ))}
          {!isLoading && !categories?.length && (
            <p className="text-sm text-gray-500 py-1">No categories found.</p>
          )}
        </div>
      </div>
    </div>
  )
}
